export default __webpack_public_path__ + "349f34691d1f8e7309d424435b910a02.png";